import type { TargetAudience } from "../types";

export const formatAudience = (audience: TargetAudience) =>
    audience
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());

export const formatExpiry = (value: string) => {
    if (!value) return null;

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;

    return date.toLocaleString("en-NG", {
        dateStyle: "medium",
        timeStyle: "short",
    });
};

export const splitLines = (value: string) =>
    value
        .split("\n")
        .map((item) => item.trim())
        .filter(Boolean);

export const joinBlocks = (blocks: Array<string | null | undefined>) =>
    blocks
        .map((block) => block?.trim())
        .filter(Boolean)
        .join("\n\n");

export const formatListBlock = (label: string, value: string) => {
    const items = splitLines(value);
    if (items.length === 0) return null;

    return `${label}:\n${items.map((item) => `- ${item}`).join("\n")}`;
};

export const formatMetaBlock = (
    targetAudience: TargetAudience,
    targetRegion: string,
    expiresAt: string
) => {
    const formattedExpiry = formatExpiry(expiresAt);
    const metaRows = [
        `Audience: ${formatAudience(targetAudience)}`,
        targetRegion.trim() ? `Region: ${targetRegion.trim()}` : null,
        formattedExpiry ? `Expires: ${formattedExpiry}` : null,
    ].filter(Boolean);

    return metaRows.length > 0 ? metaRows.join("\n") : null;
};
